// extracted by mini-css-extract-plugin
export default {"toast":"style_toast__jjkiZ","toastText":"style_toastText__eqLPw"};